<template>
  <section v-if="this.$store.getters['notice/notice'] != null" class="noticeArea_wrapper wrapper accent_light" :class="{fixed: fixed}">
    <div class="noticeArea_inner flex_center">
      <div class="message_wrapper">
        <p>
          <RawHtml :text="$store.getters['notice/notice']" />
        </p>
      </div>
      <div @click="deleteNotice" class="closeBtn_wrapper iconBtn">
        <p><fa-icon icon="times" /></p>
      </div>
    </div>
  </section>
</template>

<script>
import RawHtml from "../elements/RawHtml"
export default {
  name: "Notice",
  components: {RawHtml},
  data() {
    return {
      scrollY: 0
    }
  },
  methods: {
    deleteNotice() {
      this.$store.dispatch("notice/deleteNotice")
    }
  },
  props: {
    fixed: {
      type: Boolean,
      required: true
    }
  }
}
</script>
